<template>
  <div class="w-100-fluid mt-5">
    <div class="row">
      <div class="col-3 col-md-3 col-lg-3 col-xl-3">
        <CardInfo :cardData="cards.seller" title="Seller"/>
      </div>
      <div class="col-4 col-md-4 col-lg-4 col-xl-4">
        <CardInfo :cardData="cards.withdraw" title="Withdraw Status"/>
      </div>
    </div>
    <div class="withdraw-content">
      <TableBasic :payload="payloadTable">
        <template v-slot:header>
            <div class="info">
              <div class="list seller">
                <img src="@/assets/pmarketlogoonly.png" alt="seller_logo"/>
                <div class="detail">
                  <span class="title">{{seller.store_name}}</span>
                  <span class="value">
                    <font-awesome-icon icon="fa-solid fa-location-dot" class="pe-2 text-secondary" />
                    {{seller.addresses?.[0]?.address_detail?.city}}
                  </span>
                </div>
              </div>
              <template v-for="data in headerData" :key="data.title">
                <div class="list">
                  <span class="title">{{data.title}}</span>
                  <span class="value">{{data.value}}</span>
                </div>
              </template>
          </div>
        </template>

        <template v-slot:amount_withdraw="{data}">
          {{ filters.rupiah(data.amount - data.admin_fee) }}
        </template>

        <template v-slot:bank_name="{data}">
          {{ data.bank_info.bank_name }}
        </template>

        <template v-slot:bank_account_name="{data}">
          {{ data.bank_info.account_name }}
        </template>

        <template v-slot:bank_account_number="{data}">
          {{ data.bank_info.account_number }}
        </template>

      </TableBasic>
    </div>

    <div v-if="withdraw.withdraw_status==='PENDING'" class="row mt-4">
      <div class="d-flex" :style="{ gap: '1rem' }">
        <a class="btn fw-bold text-danger border-danger" data-bs-target="#reject-modal" data-bs-toggle="modal">
          <font-awesome-icon class="text-danger me-2" icon="fa-solid fa-times"/>
          <span>REJECT WITH NOTE</span>
        </a>
        <a class="btn btn-danger" data-bs-target="#approve-modal" data-bs-toggle="modal" style="margin-right: 5px">
          <font-awesome-icon class="text-white me-2" icon="fa-solid fa-check"/>
          <strong class="text-white">APPROVE WITHDRAW</strong>
        </a>
      </div>
    </div>

    <ApproveModal :payload="dataApprove"/>
    <RejectModal :payload="dataReject"/>
  </div>

</template>

<script>
import ApproveModal from "@/components/modals/Approve";
import RejectModal from "@/components/modals/Reject";
import CardInfo from "@/components/CardInfo.vue";
import TableBasic from "@/components/TableBasic.vue";

export default {
  components: {
    ApproveModal,
    RejectModal,
    CardInfo,
    TableBasic,
  },
  created() {
    const listRoute = this.$route.path.split("/");
    this.id = listRoute[listRoute.length - 1]
    this.dataApprove.body.seller_withdraw_id = this.id
    this.dataReject.body.seller_withdraw_id = this.id
  },
  data() {
    return {
      seller: {},
      withdraw: {},
      headerData: [],
      cards: {
        seller: {
          value: "",
          color: "yellow",
        },
        withdraw: {
          value: "",
          color: "red",
        }
      },
      payloadTable: {},
      dataApprove: {
        formLabel: "Select Withdraw Date",
        titleModal: "WITHDRAW APPROVE",
        textButton: "WITHDRAW",
        actionPath: "withdraw/approve",
        body: {
          seller_withdraw_id: "",
          approve_time: "",
        }
      },
      dataReject: {
        formLabel: "Enter rejection reason",
        titleModal: "REJECT WITHDRAW",
        textButton: "REJECT",
        actionPath: "withdraw/reject",
        body: {
          seller_withdraw_id: "",
          reason: "",
        }
      },
    }
  },
  methods: {
    parseStatus(status){
      if(status === "PENDING") return "Pending"
      if(status === "SUCCESS") return "Approved"
      if(status === "REJECT")  return "Rejected"
      return ""
    },
    parseColor(status) {
      if (status == "PENDING") return "#FFB200";
      if (status == "SUCCESS") return "#30CB9D";
      if (status == "REJECT") return "#ED413F";
      return "";
    },
    async getData() {
      const {seller, withdraw} = await this.$store.dispatch("withdraw/show", this.id)
      const cardsData = {
        seller: {
          value: seller.store_name,
          color: "yellow",
        },
        withdraw: {
          value: this.parseStatus(withdraw.withdraw_status),
          color: "red",
          color_text: this.parseColor(withdraw.withdraw_status),
        }
      }

      const tableStyle = {
        headerStyle: {backgroundColor: '#f3f2f8'},
        columnStyle: {backgroundColor: '#f9f9fc'},
        style:{padding: '1rem'}
      }

      const payload = {
        wrapperStyle: {
          backgroundColor: '#fff',
          padding: '0.75rem',
        },
        header: [
          {
            key: "amount",
            label: "AMOUNT REQUESTED",
            isCurrency: true,
            ...tableStyle
          },
          {
            key: "admin_fee",
            label: "ADMIN FEE",
            isCurrency: true,
            ...tableStyle
          },
          {
            key: "amount_withdraw",
            label: "AMOUNT WITHDRAWN",
            ...tableStyle
          },
          {
            key: "bank_name",
            label: "BANK NAME",
            ...tableStyle
          },
          {
            key: "bank_account_name",
            label: "BANK ACCOUNT NAME",
            ...tableStyle
          },
          {
            key: "bank_account_number",
            label: "BANK ACCOUNT NUMBER",
            ...tableStyle
          },
        ],
        value: [
          withdraw
        ],
        status: ''
      }

      const header = [
        {
          title: "Withdraw ID",
          value: withdraw.id
        },
        {
          title: "Requested Date",
          value: this.filters.dateFull(withdraw.created_date)
        }
      ]

      if(withdraw.withdraw_status === "SUCCESS"){
        header.push({
          title: "Approved Date",
          value: this.filters.dateFull(withdraw.approve_date)
        })
      }

      if(withdraw.withdraw_status === "REJECT"){
        header.push({
          title: "Rejected Date",
          value: this.filters.dateFull(withdraw.updated_date)
        })
        payload.header.push({
          key: "reason",
          label: "REJECTION REASON",
          ...tableStyle
        })
      }

      this.payloadTable = payload
      this.seller = seller
      this.withdraw = withdraw
      this.dataApprove.minDate = withdraw.created_date
      this.cards = cardsData
      this.headerData = header
    }
  },
  mounted() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.withdraw-content{
  display: flex;
  flex-direction: column;

  .info{
    display: flex;
    gap: 1rem;
    background-color: #fff;
    padding: 0 0.75rem;
    padding-top: 1rem;
    padding-bottom: 0.5rem;

    .list{
      display: flex;
      flex-direction: column;
      width: 200px;

      .title{
        color: #929293;
      }

      .value{
        font-weight: 700;
      }


      &.seller{
        flex-direction: row;
        align-items: center;

        & img{
          width: 30px;
          height: 30px;
          background-color: #e1e4ed;
          margin-right: 10px;
          border-radius: 4px;
        }
        .detail{
          display: flex;
          flex-direction: column;

          .title{
            font-weight: 700;
            color: #5e50a1;
          }
          .value{
            color: #5e50a1;
          }
        }
      }
    }
  }
}
.error-border {
  border: 1px red solid !important;
}
</style>